import * as React from 'react'
import { FC, useRef, useCallback, Children } from 'react'

import { ArrowLeft, ArrowRight } from '../../../Icons'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/swiper.scss'

import './Carousel.scss'

interface Props {
    children?: React.ReactNode
    onUpdate?: (swiper: Swiper) => void
    slidesPerView?: number
    spaceBetween?: number
    className?: string
    centeredSlides?: boolean
    loop?: boolean
    breakpoints?: any
}

const Carousel: FC<Props> = ({
    children,
    onUpdate,
    slidesPerView = 4,
    spaceBetween = 50,
    className = '',
    centeredSlides = false,
    loop = false,
    breakpoints,
}) => {
    const swiperInstance = useRef<Swiper>()
    const onPrevHandle = useCallback(() => {
        // @ts-ignore
        swiperInstance.current?.slidePrev()
    }, [swiperInstance])

    const onNextHandle = useCallback(() => {
        // @ts-ignore
        swiperInstance.current?.slideNext()
    }, [swiperInstance])

    return (
        <div className={`Carousel ${className}`}>
            <div className="Carousel__controls">
                <button onClick={onPrevHandle}>
                    <ArrowLeft />
                </button>
                <button onClick={onNextHandle}>
                    <ArrowRight />
                </button>
            </div>
            <Swiper
                spaceBetween={spaceBetween}
                slidesPerView={slidesPerView}
                onSlideChange={(swiper) => {
                    // @ts-ignore
                    onUpdate?.(swiper)
                }}
                onSwiper={(swiper) => {
                    // @ts-ignore
                    swiperInstance.current = swiper
                    // @ts-ignore
                    onUpdate?.(swiper)
                }}
                centeredSlides={centeredSlides}
                loop={loop}
                breakpoints={breakpoints}
            >
                {Children.map(children, (child, index) => (
                    <SwiperSlide key={index}>{child}</SwiperSlide>
                ))}
            </Swiper>
        </div>
    )
}

export default Carousel
